import type { Lang } from '../types/funnel';

export function usd(n: number, lang: Lang = 'en'): string {
  return new Intl.NumberFormat(lang === 'es' ? 'es-US' : 'en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: n % 1 === 0 ? 0 : 2,
  }).format(n);
}

export function hrs(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

export function digitsOnly(s: string): string {
  return s.replace(/\D/g, '');
}

export function formatPhone(s: string): string {
  const d = digitsOnly(s).slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
